<template>
  <div class="wap-videolist">
    <div v-if="!ReplayliveState" class="wap-videolist-box">
      <div v-for="(list, idx) in videoPlayBackList" :key="list.newId">
        <div class="videolist-list">
          <div class="videolist-cover">
            <a
              @click="toNewPager(list, idx)"
              :class="{ 'a-no-hover': !list.url }"
            >
              <img v-bind:src="list.mapId" alt="" />
            </a>
          </div>
          <div class="videolist-main">
            <div class="videolist-name" :title="list.title">
              {{ list.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="ReplayliveState" class="wap-videolist-box">
      <div v-for="item in wapPackBackVideoList" :key="item.id">
        <div class="videolist-list">
          <div class="videolist-cover">
            <a>
              <img v-bind:src="item.img" alt="" />
            </a>
          </div>
          <div class="videolist-main">
            <div class="videolist-name">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { $subscriber, cr, URLS } from "fire-wind-water";
import getHlsSite from "../../common/getHlsSite";
import { socketModule } from "../../common/socket";
import comonService from "../../services/comonService";
// let player;
export default {
  name: "VideoLists",
  data() {
    return {
      webinarInfo: null,
      videoPlayBackList: [],
      defaultImage: require("../../assets/images/moren-tuijian.jpg"),
      currentVideoId: "", //当前播放的视频id
      isPlay: false, //视频是否是播放状态
      wapPackBackVideoList: [],
      ReplayliveState:
        window.location.href.indexOf("liveState=replay") > -1 &&
        window.location.href.indexOf("isSetting=1") > -1
          ? true
          : false //静态链接回放状态
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      $subscriber.subscribe("webinarInfo", data => {
        this.webinarInfo = data;
      });
      $subscriber.subscribe("webinarInfo-videoList", data => {
        this.videoPlayBackList = data;
        if (data.length > 0) {
          let type = URLS.getURL("type");
          if(type=='am' || !type || data.length == 1){
            this.defaultPlayback(data[0], 0);
          }else{
            this.defaultPlayback(data[1], 0);
          }
        }
      });
      $subscriber.subscribe("playerButtonStatus", data => {
        this.isPlay = data;
      });
      $subscriber.subscribe("simulateClickEvent", data => {
        this.toNewPager(data.href, data.idx);
      });
      $subscriber.subscribe("wapPackBackVideoList", data => {
        this.wapPackBackVideoList = data;
      });
      $subscriber.off("check-video-index");
      $subscriber.subscribe("check-video-index", index => {

        if (this.videoPlayBackList[index]) {
          this.toNewPager(this.videoPlayBackList[index], index);
          // this.defaultPlayback(data[0], 0);
        }
      });


    },
    toNewPager(href, idx) {
      //判断当前点击的视频 与正在播放的视频id是否相等  若相等不进行后续操作 跳出
      if (this.currentVideoId === href.videoId) {
        return;
      }
      if (this.isPlay) {
        //切换视频 如果正在播放中那么 断开socket
        socketModule.disconnect();
        $subscriber.emit("muduPlayerIsPlay", false);
        this.isPlay = false;
      }
      // 若当前id不相等 把id保存起来 或者通过player 传过去
      let currentVideoId = href.videoId;
      this.currentVideoId = currentVideoId;
      if (this.videoPlayBackList.length > 0) {
        var videoList = this.videoPlayBackList;
        var hlsSite;
        var webcastId = this.webinarInfo.webcastId; //频道id
        var isHavePpt = href.isBindPpt == "1" ? true : false; //一堆列表里面是否有ppt的  用来初始化不同的效果
        //获取 hlsSite
        hlsSite = getHlsSite.getHlsSite(videoList, currentVideoId);
        window.$sk.webinar.skSdkEvent({
          type: "switchVideo",
          data: {
            webcastId: webcastId,
            tenantId: this.webinarInfo.tenantId,
            videoBg: href.mapId,
            type: this.webinarInfo.replaySwitch == 1 ? "playback" : "live",
            hlsSite: this.webinarInfo.replaySwitch == 1 ? hlsSite : null,
            currentVideoId: currentVideoId,
            videoPlayBackList: this.videoPlayBackList,
            isHavePpt: isHavePpt,
            idx: idx,
            webCastProvider: this.webinarInfo.webCastProvider,
            needPpt: isHavePpt,
            nowVideo: href,
            isPlay: this.isPlay
          }
        });
        //增加播放次数
        this.service.postVideoIncTimes({
          tenantId: this.webinarInfo.tenantId,
          webinarId: this.webinarInfo.webinarId,
          videoId: href.videoId
        });
      }
    },
    defaultPlayback(href, idx) {
      this.currentVideoId = href.videoId;
      let videoList = this.videoPlayBackList;
      //获取 hlsSite
      let hlsSite = getHlsSite.getHlsSite(videoList, href.videoId);
      let isHavePpt = href.isBindPpt == "1" ? true : false;
      window.$sk.webinar.skSdkEvent({
        type: "init",
        data: {
          webcastId: this.webinarInfo.webcastId,
          tenantId: this.webinarInfo.tenantId,
          videoBg: href.mapId,
          type: this.webinarInfo.replaySwitch == 1 ? "playback" : "live",
          hlsSite: this.webinarInfo.replaySwitch == 1 ? hlsSite : null,
          currentVideoId: href.videoId,
          videoPlayBackList: this.videoPlayBackList,
          isHavePpt: isHavePpt,
          webCastProvider: this.webinarInfo.webCastProvider,
          needPpt: isHavePpt,
          nowVideo: href
        }
      });
      //增加播放次数
      this.service.postVideoIncTimes({
        tenantId: this.webinarInfo.tenantId,
        webinarId: this.webinarInfo.webinarId,
        videoId: href.videoId
      });
    },
    //获取真正的播放地址
    //如果videoOrigin中是m3u8第1优先用它，如果不是第2优先用转码信息中的url，它应该是m3u8，如果没有那还是用videoOrigin
    //以前的旧数据videoOrigin中就是m3u8。后来不知道什么时候变成了mp4/flv这样的格式。
    getRealMudoVodUrl(video) {
      var hlsSite =
        video.transcodeData &&
        video.transcodeData[0] &&
        video.transcodeData[0]["url"]
          ? video.transcodeData[0]["url"]
          : video.videoOrigin;
      if (video && video.videoOrigin) {
        var tempArray = video.videoOrigin.split(".");
        if (tempArray[tempArray.length - 1] === "m3u8") {
          hlsSite = video.videoOrigin;
        }
      }
      return hlsSite;
    }
  }
};
</script>

<style scoped></style>
